module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_m_albino.cee7d3ee.png";